import { AppShell } from "@mantine/core";
import { memo, type FC, type PropsWithChildren } from "react";

const headerConfig = {
  height: 48,
};

const navConfig = {
  width: 0,
  breakpoint: "sm",
  collapsed: {
    mobile: false,
  },
};

export const PublicDashboardLayout: FC<PropsWithChildren> = memo(({ children }) => {
  return (
    <AppShell
      header={headerConfig}
      navbar={navConfig}
      padding="md"
    >
      <AppShell.Main>
        {children}
      </AppShell.Main>
    </AppShell>
  );
});
